import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem('lenmo_token');
    const storedUser = localStorage.getItem('lenmo_user');
    if (storedToken && storedUser) {
      setToken(storedToken);
      setUser(JSON.parse(storedUser));
    }
    setLoading(false);
  }, []);

  const login = useCallback((tokenData, userData) => {
    localStorage.setItem('lenmo_token', tokenData);
    localStorage.setItem('lenmo_user', JSON.stringify(userData));
    setToken(tokenData);
    setUser(userData);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem('lenmo_token');
    localStorage.removeItem('lenmo_user');
    setToken(null);
    setUser(null);
  }, []);

  const isAdmin = user?.role === 'admin' && user?.type === 'staff';
  const isViewer = user?.role === 'viewer' && user?.type === 'staff';
  const isStaff = user?.type === 'staff';
  const isMember = user?.type === 'member';

  return (
    <AuthContext.Provider value={{
      user, token, loading, login, logout,
      isAdmin, isViewer, isStaff, isMember,
    }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export default AuthContext;
